// Reserved ad placeholder. Fixed height to avoid layout shift (CLS).
// variants: "inline" (medium rectangle), "banner" (horizontal, low), "rail" (sidebar skyscraper).
export const AdSlot = ({ variant = "inline", className = "" }) => {
  const size =
    variant === "rail"
      ? "min-h-[600px] sticky top-24"
      : variant === "banner"
      ? "min-h-[100px] sm:min-h-[120px]"
      : "min-h-[250px]";
  const testid =
    variant === "rail" ? "ad-slot-rail" : variant === "banner" ? "ad-slot-banner" : "ad-slot-inline";
  return (
    <div
      data-testid={testid}
      className={`rounded-2xl border bg-muted/30 p-3 flex flex-col gap-2 ${size} ${className}`}
      aria-label="Werbeplatz"
    >
      <span className="text-[10px] uppercase tracking-wider text-muted-foreground">Anzeige</span>
      <div className="flex-1 rounded-xl border border-dashed border-border/70 flex items-center justify-center">
        <span className="text-xs text-muted-foreground">Werbeplatz reserviert</span>
      </div>
    </div>
  );
};
